<div class="forgot-password-cont">
  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="onSubmit()"
    class="forgot-password-form shadow-lg"
  >
    <h2 style="text-align: center" class="mb-3">Forgot Password</h2>
    <div class="form-group">
      <label for="email" class="d-block forgot-password-labels">Email</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="forgot-password-inputs"
        placeholder="johndoe@gmail.com"
        required
      />
      <div
        *ngIf="
          forgotPasswordForm.get('email')!.hasError('required') &&
          forgotPasswordForm.get('email')!.touched
        "
      >
        Email is required.
      </div>
      <div
        *ngIf="
          forgotPasswordForm.get('email')!.hasError('email') &&
          forgotPasswordForm.get('email')!.touched
        "
      >
        Please enter a valid email address.
      </div>
    </div>

    <div class="form-group" *ngIf="otpSent">
      <label for="otp" class="d-block forgot-password-labels">OTP</label>
      <input
        type="text"
        id="otp"
        formControlName="otp"
        class="forgot-password-inputs"
        placeholder="Enter OTP"
        required
      />
      <div
        *ngIf="
          forgotPasswordForm.get('otp')!.hasError('required') &&
          forgotPasswordForm.get('otp')!.touched
        "
      >
        OTP is required.
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <!-- <app-button
        type="submit"
        [label]="otpSent ? 'Confirm' : 'Send Mail'"
        class="btn-primary"
        [disabled]="forgotPasswordForm.invalid"
      ></app-button> -->
    </div>
  </form>
</div>
